// extracted by mini-css-extract-plugin
export default {"root":"PanelGroup_root__ikwRp","description":"PanelGroup_description__RqxC7"};